import { TitleCasePipe } from '@angular/common';
import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import { CreditCard } from '@df/session/api/credit-cards/credit-card';
import { ActionInlineComponent } from '../../../ui/display/action-inline/action-inline.component';
import { Section2Component } from '../../../ui/display/section2/section2.component';
import { AccountSavedCardBodyComponent } from '../body/account-saved-card-body.component';
@Component({
    selector: 'account-saved-card-item',
    templateUrl: './account-saved-card-item.html',
    styleUrls: ['account-saved-card-item.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: true,
    imports: [ActionInlineComponent, TitleCasePipe, AccountSavedCardBodyComponent, TitleCasePipe, Section2Component]
})
export class AccountSavedCardItemComponent {
    /**
     * Card model
     */
    @Input()
    card?: CreditCard;
}
